import { type FC } from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react-lite'
import { Icon, type IIconProps } from 'shared/ui'
import { type IInboxCombine } from 'entities/Inbox'
import styles from './styles.module.scss'

export type PropsInboxTag = {
  className?: string
  iconProps?: IIconProps
  inbox: IInboxCombine
}

export const InboxTag: FC<PropsInboxTag> = observer(({ inbox, iconProps, className }) => {
  return (
    <div className={classnames(styles.wrap, className)}>
      <span className={styles.icon}>
        <Icon icon={inbox.icon} {...iconProps} />
      </span>
      <span className={styles.name}>{inbox.name}</span>
    </div>
  )
})
